import type {
  ParameterValueAmendOperation,
  ParameterValueCreateOperation,
} from '@festina/configuration-general-types/configuration'
import { isParameterValueAmendOperation } from '@festina/configuration-general-types/configuration'
import { listUtils } from '@festina-life/core'

import type { OperationWithSourceInfo } from '../types'
import type { ParameterValueOperation } from './types'

const isAmendOperation = (
  operation: OperationWithSourceInfo<ParameterValueOperation>,
): operation is OperationWithSourceInfo<ParameterValueAmendOperation> =>
  isParameterValueAmendOperation(operation.internalOperation)

/**
 * Splits a collection of indexed parameter value operations into the ones that create a
 * value and the ones that amend an existing one.
 * A large operation counts as a create: `ConfigurationOperationType` only models
 * `parameterValueCreate`.
 */
export const partitionValueOperations = (
  operations: OperationWithSourceInfo<ParameterValueOperation>[],
): {
  creates: OperationWithSourceInfo<ParameterValueCreateOperation>[]
  amends: OperationWithSourceInfo<ParameterValueAmendOperation>[]
} => {
  const [amends, creates] = listUtils.partition(operations, isAmendOperation)

  return { creates, amends }
}

/**
 * Whether the given collection of parameter value operations contains any amendment.
 */
export const hasAmendOperations = (
  operations: OperationWithSourceInfo<ParameterValueOperation>[],
): boolean => operations.some(isAmendOperation)
